import React from "react";
import {
  Container,
  HeaderWrapper,
  TableHeader,
  ButtonWrapper,
  CustomHelpIcon,
  InfoContainer,
  NullDescription,
  NullMessage,
  NullPage,
  MainHeaderContainer,
  HelpContainer,
  HelpIcon,
  HelpTooltip,
  Title,
  TextContainer,
  LeftContainer,
  SwitchWrapper,
  IconContainer,
  SwitchContainer,
  UserTypeText,
} from "./styles";
import { RequestModal } from "../../components/RequestModal";
import { Button, Divider } from "@mui/material";
import { StickyTable } from "../../components/StickyTable";
import Spinner from "../../components/Spinner/Spinner";
import { getUsersList } from "../../services/user/getUser";
import theme from "../../theme/theme";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownAltIcon from "@mui/icons-material/ThumbDownAlt";
import { getAdminReservationsList } from "../../services/reservations/getReservations";
import { InputModal } from "../../components/InputModal";
import { Menu } from "../../components/Menu";
import { getSystem } from "../../services/system/getSystem";
import { putSystem } from "../../services/system/putSystem";
import Switch, { SwitchProps } from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import { Lock } from "@mui/icons-material";
import { IconSection } from "../AdminPanel/styles";


const IOSSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color:
          theme.palette.mode === "light"
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));
 
const ReservationList = () => {
  // ------------------- JWT -------------------
  const jwt = localStorage.getItem("jwt");

  // ------------------- CONFIG SECTIONS -------------------
  const configReservations = [
    { name: "Pendientes" },
    { name: "Aprobadas" },
    { name: "Negadas" },
    { name: "No disponibles" },
    { name: "En progreso" },
  ];

  // ------------------- STATES -------------------
  const [reservationId, setReservationId] = React.useState(0);
  const [tableFeatures, setTableFeatures] = React.useState<any>([]);
  const [loadingReservationList, setLoadingReservationList] =
    React.useState(false);
  const [reservationList, setReservationList] = React.useState<any>(null);
  const [reservationListData, setReservationListData] =
    React.useState<any>(null);
  const [systemStatus, setSystemStatus] = React.useState(false);

  const [isPosted, setIsPosted] = React.useState(false);
  const [invalid, setInvalid] = React.useState(false);
  const [warningMessage, setWarningMessage] = React.useState("");

  const [openAcceptModal, setOpenAcceptModal] = React.useState(false);
  const [openDenyModal, setOpenDenyModal] = React.useState(false);
  const [reloadPage, setReloadPage] = React.useState(false);

  const [loadingUsersList, setLoadingUsersList] = React.useState(false);
  const [loadingData, setLoadingData] = React.useState(false);
  const [usersList, setUsersList] = React.useState<any>(null);
  const [title, setTitle] = React.useState("");
  const [isEmpty, setIsEmpty] = React.useState(false);

  // ------------------- USE EFFECT -------------------
  React.useEffect(() => {
    setLoadingUsersList(true);
    setLoadingReservationList(true);
    setLoadingData(true);
    getUsers();
    getSystemStatus();
  }, []);

  React.useEffect(() => {
    if (usersList) {
      getReservations();
    }
  }, [usersList]);

  React.useEffect(() => {
    if (reservationListData) {
      setLoadingData(false);
    }
  }, [reservationListData]);

  React.useEffect(() => {
    if (reloadPage) {
      setLoadingReservationList(true);
      if (title === "En progreso") {
        fetchInProgressReservations("In Progress");
      } else if (title === "Aprobadas") {
        fetchReservations("Approved");
      } else if (title === "Negadas") {
        fetchReservations("Rejected");
      } else if (title === "No disponibles") {
        fetchReservations("Not available");
      } else {
        fetchReservations("Pending");
      }
      setReloadPage(false);
    }
  }, [reloadPage]);

  // React.useEffect(() => {
  //     // setLoadingData(true);
  //     getSystemStatus();
  // }, [systemStatus]);

  // ------------------- GET RESERVATIONS FROM API -------------------
  const getReservations = async () => {
    await getAdminReservationsList(jwt!, "Pending", "", "")
      .then((res: any) => {
        if (res && res.data) {
          setReservationList(res.data);
          handleData(res.data, "Pending");
          if (res.data.length === 0) {
            setIsEmpty(true);
          } else {
            setIsEmpty(false);
          }
        }
      })
      .catch((err: any) => {
        console.log(err, "err");
      });

    setTitle("Pendientes");
    setLoadingReservationList(false);
  };

  const fetchReservations = async (state: string) => {
    await getAdminReservationsList(jwt!, state, "", "")
      .then((res: any) => {
        if (res && res.data) {
          setReservationList(res.data);
          handleData(res.data, state);
          if (res.data.length === 0) {
            setIsEmpty(true);
          } else {
            setIsEmpty(false);
          }
        }
      })
      .catch((err: any) => {
        console.log(err, "err");
      });

    setLoadingReservationList(false);
  };

  const fetchInProgressReservations = async (state: string) => {
    await getAdminReservationsList(jwt!, state, "", "")
      .then((res: any) => {
        if (res && res.data) {
          setReservationList(res.data);
          handleDataInProgress(res.data);
          if (res.data.length === 0) {
            setIsEmpty(true);
          } else {
            setIsEmpty(false);
          }
        }
      })
      .catch((err: any) => {
        console.log(err, "err");
      });

    setLoadingReservationList(false);
  };

  const getUsers = async () => {
    await getUsersList(jwt!)
      .then((res: any) => {
        if (res && res.data) {
          setUsersList(res.data);
        }
      })
      .catch((err: any) => {
        console.log(err, "err");
      });

    setLoadingUsersList(false);
  };

  const getSystemStatus = async () => {
    await getSystem(jwt!)
      .then((res: any) => {
        if (res && res.data) {
          setSystemStatus(res.data.is_active);
        }
      })
      .catch((err: any) => {
        console.log(err, "err");
      });
  };

  const modifySystemStatus = async () => {
    await putSystem(jwt!)
      .then((res: any) => {
        // setSystemStatus(res.data.is_active);
        if (res && res.data) {
          if (res.status > 299) {
            setSystemStatus(!systemStatus);
            setInvalid(true);
            setWarningMessage("El sistema no pudo ser modificado");
          } else {
            setIsPosted(true);
            if (!systemStatus) {
              setWarningMessage(
                "Los usuarios serán capaces de hacer reservaciones"
              );
            } else {
              setWarningMessage("Los usuarios no podrán hacer reservaciones");
            }
          }
        }
      })
      .catch((err: any) => {
        console.log(err, "err");
      });
  };

  const handleToggle = () => {
    setSystemStatus(!systemStatus);
    modifySystemStatus();
  };

  const handleClose = () => {
    if (invalid) {
      setInvalid(false);
      setIsPosted(false);
      setWarningMessage("");
      window.location.reload();
    }
    setInvalid(false);
    setIsPosted(false);
    setWarningMessage("");
  };

  // ------------------- TABLE PARAMS -------------------
  const reservationCols = [
    { id: "email", label: "Correo", minWidth: 120 },
    { id: "resource_name", label: "Recurso", minWidth: 170 },
    { id: "start", label: "Inicio", minWidth: 170 },
    { id: "finish", label: "Fin", minWidth: 170 },
    { id: "actions", label: "Acciones", minWidth: 100 },
  ];

  const reservationInProgressCols = [
    { id: "email", label: "Correo", minWidth: 120 },
    { id: "resource_name", label: "Recurso", minWidth: 170 },
    { id: "start", label: "Inicio", minWidth: 170 },
    { id: "finish", label: "Fin", minWidth: 170 },
  ];

  // ------------------- HANDLERS -------------------
  const handleConfigSection = (category: string) => {
    setLoadingReservationList(true);
    setLoadingData(true);
    if (category === "Pendientes") {
      fetchReservations("Pending");
      setTitle("Pendientes");
    } else if (category === "Aprobadas") {
      fetchReservations("Approved");
      setTitle("Aprobadas");
    } else if (category === "Negadas") {
      fetchReservations("Rejected");
      setTitle("Negadas");
    } else if (category === "No disponibles") {
      fetchReservations("Not available");
      setTitle("No disponibles");
    } else if (category === "En progreso") {
      fetchInProgressReservations("In Progress");
      setTitle("En progreso");
    }
  };

  const handleData = (response: any, status: string) => {
    let showApproveButton = false;
    let showDenyButton = false;

    if (status === "Pending" || status === "Not available") {
      showApproveButton = true;
      showDenyButton = true;
    } else if (status === "Approved") {
      showDenyButton = true;
    } else if (status === "Rejected") {
      showApproveButton = true;
    }

    const reservationListRows = response.map((reservation: any) => ({
      email: handleUserEmail(reservation.user),
      resource_name: reservation.resource_name,
      start: handleDate(reservation.start),
      finish: handleDate(reservation.finish),
      actions: (
        <>
          <ButtonWrapper>
            {showApproveButton && (
              <Button
                variant="contained"
                color="success"
                onClick={() => {
                  setReservationId(reservation.id);
                  setOpenAcceptModal(true);
                }}
              >
                <ThumbUpAltIcon
                  sx={{ color: theme.color.white, fontSize: "20px" }}
                />
              </Button>
            )}

            {showDenyButton && (
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  setReservationId(reservation.id);
                  setOpenDenyModal(true);
                }}
              >
                <ThumbDownAltIcon
                  sx={{ color: theme.color.white, fontSize: "20px" }}
                />
              </Button>
            )}
          </ButtonWrapper>
        </>
      ),
    }));

    setReservationListData(reservationListRows);
    setTableFeatures(reservationCols);
  };

  const handleDataInProgress = (response: any) => {
    const reservationListRows = response.map((reservation: any) => ({
      email: handleUserEmail(reservation.user),
      resource_name: reservation.resource_name,
      start: handleDate(reservation.start),
      finish: handleDate(reservation.finish),
    }));

    setReservationListData(reservationListRows);
    setTableFeatures(reservationInProgressCols);
  };

  const handleUserEmail = (userId: number) => {
    const user = usersList.find((user: any) => user.id === userId);
    const response = user ? user.email : "Usuario desconocido";
    return response;
  };

  const handleDate = (date: string) => {
    const myDate = new Date(date).toLocaleDateString("es-MX");
    const myTime = new Date(date).toLocaleTimeString("es-MX", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "America/Mexico_City",
    });
    return myDate + "\n" + myTime;
  };

  const mensaje = (
    <div>
      Este es un mensaje de ayuda más largo. Puede contener varias líneas de
      texto. También puedes incluir HTML o componentes personalizados aquí.
    </div>
  );

  return (
    <>
      {openAcceptModal && (
        <InputModal
          title="¿Desea aprobar reservación?"
          description="Favor de agregar un mensaje para el usuario"
          action="ApproveReservation"
          reservationID={reservationId}
          buttonMessage="Aprobar"
          onClose={() => setOpenAcceptModal(false)}
          update={() => setReloadPage(true)}
        />
      )}

      {openDenyModal && (
        <InputModal
          title="¿Desea denegar reservación?"
          description="Favor de agregar un mensaje para el usuario"
          action="DenyReservation"
          reservationID={reservationId}
          buttonMessage="Denegar"
          onClose={() => setOpenDenyModal(false)}
          update={() => setReloadPage(true)}
        />
      )}

      {isPosted ? (
        <RequestModal
          title="¡Sistema de reservaciones modificado!"
          description={warningMessage}
          onClose={handleClose}
        />
      ) : (
        invalid && (
          <RequestModal
            title="Ocurrió un error"
            description={warningMessage}
            onClose={handleClose}
          />
        )
      )}

      <Container>
        <MainHeaderContainer>
          <LeftContainer>
            <HeaderWrapper>
              <Title>Reservaciones</Title>
            </HeaderWrapper>
            <HelpContainer>
              <HelpIcon>
                <CustomHelpIcon />
              </HelpIcon>
              <HelpTooltip>
                <p>
                  <strong>Pendientes:</strong> Reservaciones que necesitan
                  validación.
                </p>
                <p>
                  <strong>Aprobadas:</strong> Reservaciones autorizadas.
                </p>
                <p>
                  <strong>Negadas:</strong> Reservaciones denegadas.
                </p>
                <p>
                  <strong>No disponible:</strong> El horario seleccionado no
                  está disponible.
                </p>
                <p>
                  <strong>En progreso:</strong> Reservaciones en curso.
                </p>
              </HelpTooltip>
            </HelpContainer>
          </LeftContainer>
          {/* <ToggleButtonWrapper>
                        <Label>
                            <Input type="checkbox" checked={systemStatus} onChange={handleToggle} />
                            <Slider />
                        </Label>
                        <TextContainer>
                            <Text>Sistema de reservaciones:</Text>
                            <TextBold>{systemStatus ? 'Activado' : 'Desactivado'}</TextBold>
                        </TextContainer>
                    </ToggleButtonWrapper> */}
          <SwitchWrapper>
            <IconContainer>
              <Lock
                sx={{
                  color: theme.color.white,
                  backgroundColor: theme.color.stone,
                  padding: "2px",
                  borderRadius: "5px",
                }}
              />
            </IconContainer>
            <TextContainer>
            <UserTypeText>Permitir reservaciones</UserTypeText>
            </TextContainer>

            <SwitchContainer>
              <IOSSwitch
                sx={{ m: 1 }}
                checked={systemStatus}
                onChange={handleToggle}
              />
            </SwitchContainer>
          </SwitchWrapper>
        </MainHeaderContainer>
        <Divider sx={{ marginBottom: "20px" }} />
      </Container>
      <IconSection>
        <Menu
          categories={configReservations}
          onCategorySelect={handleConfigSection}
        />
      </IconSection>
      <Container>
        {!loadingReservationList && !loadingUsersList && !loadingData ? (
          isEmpty ? (
            <NullPage>
              <NullMessage>No hay Reservaciones "{title}"</NullMessage>
              <NullDescription>
                Todas las solicitudes han sido resueltas
              </NullDescription>
            </NullPage>
          ) : (
            <InfoContainer>
              <HeaderWrapper>
                <TableHeader>{title}</TableHeader>
              </HeaderWrapper>
              <Divider sx={{ marginBottom: "20px" }} />
              <StickyTable
                columns={tableFeatures}
                rows={reservationListData || []}
                key={reservationListData}
              />
            </InfoContainer>
          )
        ) : (
          <Spinner />
        )}
      </Container>
    </>
  );
};

export default ReservationList;
